<button type="button" class="btn {{check.btnclass}}" (click)="dynamicEmit(check.target)">
    <i class="{{check.icon}} mr-2"></i> {{check.label}}
  </button>
